import { useTranslation } from 'react-i18next';
import { useTheme } from '@/components/theme/theme-provider';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
// The logo should be placed in src/assets/images/
import Logo from '@/assets/images/tulasi-circle.png';
import LogoWhite from '@/assets/images/tulasi-circle_white.png';

const HomePage = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-brand-background text-brand-brown p-4 dark:bg-gray-900 dark:text-gray-300">
      <div className="w-full max-w-4xl flex flex-col items-center">
        {/* Header Section */}
        <header className="text-center">
          <img src={theme === 'dark' ? LogoWhite : Logo} alt="Tulasi Home Logo" className="mx-auto h-60 w-60 mb-4 object-contain" />
          <h1 className="text-5xl font-bold tracking-wider text-brand-green dark:text-gray-100">
            TULASI HOME
          </h1>
          <p className="mt-2 text-sm tracking-[0.2em] text-brand-green dark:text-gray-300">
            PRINT & ARTISAN PRODUCTION STUDIO
          </p>
          <div className="my-6 w-40 mx-auto border-t border-brand-green/50 dark:border-teal-300/50"></div>
          <p className="italic text-md text-brand-brown dark:text-gray-400">
            From sacred inspiration to tangible art.
          </p>
        </header>

        {/* Main Content */}
        <main className="text-center">
          <h2 className="text-4xl font-semibold mb-8 text-brand-brown dark:text-gray-100">
            {t('welcome', 'Ласкаво просимо')}
          </h2>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Button
              disabled={true}
              variant="outline"
              className="border-brand-tan text-brand-brown hover:bg-brand-tan hover:text-white px-8 py-2 rounded-md transition-colors duration-300 dark:border-amber-800 dark:text-gray-300 dark:hover:bg-amber-800 dark:hover:text-white"
              onClick={() => navigate('/register')}
            >
              {t('auth.register', 'Реєстрація')}
            </Button>
            <Button
              asChild
              className="bg-brand-tan text-white hover:bg-opacity-90 px-8 py-2 rounded-md transition-colors duration-300 dark:bg-amber-700 dark:hover:bg-amber-600"
            >
              <Link to="/studio">{t('cta.get_started', 'Get started')}</Link>
            </Button>
            <Button
              disabled
              variant="outline"
              className="border-brand-tan text-brand-brown hover:bg-brand-tan hover:text-white px-8 py-2 rounded-md transition-colors duration-300 dark:border-amber-800 dark:text-gray-300 dark:hover:bg-amber-800 dark:hover:text-white"
              onClick={() => navigate('/about')}
            >
              {t('cta.learn_more', 'Дізнатися більше')}
            </Button>
          </div>
        </main>
      </div>

      {/* Footer Text */}
      <footer className="absolute bottom-8 text-center">
        <p className="tracking-widest text-sm text-brand-brown/80 dark:text-gray-500">
          АРТ ПРИНТ НА ПАПЕРІ ТА ПОЛОТНІ
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
